import { PanelsTopLeft, Sparkles } from 'lucide-react';

import { LABS_FEATURE } from './labs-overrides';
import { experimentCopy } from './messages';
import type { ExperimentMeta } from './registry.types';

const ADAPTIVE_LEARNING_FEEDBACK_HREF =
  'https://getheidi.canny.io/heidi-labs-feedback?selectedCategory=adaptive-learning';
const ADAPTIVE_LEARNING_LEARN_MORE_HREF =
  'https://www.heidihealth.com/support/en/articles/16144711-adaptive-learning';

/** Release gates shared by the Labs card and avatar-menu layout toggle. */
export const SESSION_LAYOUT_V2_RELEASE_FLAGS = [
  'release-scribe-enable-new-session-list',
  'release-scribe-session-page-v2',
] as const;

/**
 * The experiments offered for per-feature opt-in. Pure data — display state is
 * derived in `hooks/use-experiments.ts`, which also orders the list newest-first
 * on `addedAt`. Literal order here is therefore not the render order; add new
 * entries wherever they read best and let `addedAt` place the card.
 *
 * Session Layout V2 is the proof of concept. Its `flags` gate both the card
 * and the layout (`useIsSessionPageV2Enabled`); within that reach the Labs
 * opt-in decides who actually gets V2. The new-session-list flag is a
 * route-safety dependency and is intentionally NOT driven by the opt-in.
 */
export const EARLY_ACCESS_EXPERIMENTS: readonly ExperimentMeta[] = [
  {
    id: LABS_FEATURE.adaptiveLearning,
    title: experimentCopy[LABS_FEATURE.adaptiveLearning].title,
    summary: experimentCopy[LABS_FEATURE.adaptiveLearning].summary,
    category: 'ai',
    accent: 'purple',
    flags: ['release-scribe-adaptive-learning'],
    availability: experimentCopy[LABS_FEATURE.adaptiveLearning].availability,
    addedAt: '2026-07',
    isNew: true,
    learnMoreHref: ADAPTIVE_LEARNING_LEARN_MORE_HREF,
    feedbackHref: ADAPTIVE_LEARNING_FEEDBACK_HREF,
    media: { icon: Sparkles, imageSrc: '/images/labs-adaptive-learning.webp' },
  },
  {
    id: LABS_FEATURE.sessionLayoutV2,
    title: experimentCopy[LABS_FEATURE.sessionLayoutV2].title,
    summary: experimentCopy[LABS_FEATURE.sessionLayoutV2].summary,
    category: 'scribe',
    accent: 'purple',
    flags: [...SESSION_LAYOUT_V2_RELEASE_FLAGS],
    availability: experimentCopy[LABS_FEATURE.sessionLayoutV2].availability,
    addedAt: '2026-08',
    isNew: true,
    // A layout change only — no model or data processing for the Supplemental
    // Terms to cover, so it neither prompts for them nor is switched off by a
    // decline.
    exemptFromTerms: true,
    // No dedicated docs article for this experiment yet — the "Learn more" link
    // stays hidden until a `learnMoreHref` is added here.
    feedbackHref: 'https://heidihealth.typeform.com/to/gcNwEqnY',
    media: { icon: PanelsTopLeft, imageSrc: '/images/labs-session-layout-v2.webp' },
  },
];
